export { default } from './isImmutableStack'
